import { render, staticRenderFns } from "./trafficSourceToggle.vue?vue&type=template&id=0bbd2062"
import script from "./trafficSourceToggle.vue?vue&type=script&lang=js"
export * from "./trafficSourceToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports